var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide" } }, [
    _vm.show
      ? _c(
          "div",
          {
            staticClass: "liveRoomPop-container",
            style: { top: _vm.config.top },
          },
          [
            [
              _c("el-image", {
                staticClass: "liveRoomPop-img",
                attrs: { fit: "contain", src: _vm.config.imgUrl, lazy: "" },
              }),
              _vm._t("imgTip"),
            ],
            _c(
              "div",
              { staticClass: "liveRoomPop-contant" },
              [
                _c(
                  "div",
                  {
                    staticClass: "liveRoomPop-title",
                    class:
                      _vm.config.titleTextHidden === 2
                        ? "text_hidden"
                        : "text_hidden_1",
                  },
                  [_vm._v(_vm._s(_vm.config.title))]
                ),
                _vm._t("text"),
              ],
              2
            ),
            _c("svg-icon", {
              attrs: {
                "class-name": "liveRoomPop-close",
                "icon-class": "live_roomPopClose",
              },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleClose.apply(null, arguments)
                },
              },
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }